import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {CookieService} from 'ngx-cookie-service';
import {ApiConnectService} from './api-connect.service';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {NotificationsService} from './notifications.service';
import {UserService} from "./user.service";
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

@Injectable()
export class AuthService {
  private sessionValidated = false;

  constructor(private http: HttpClient,
              private router: Router,
              private cookieService: CookieService,
              private notificationsService: NotificationsService,
              private apiURL: ApiConnectService,
              private userService: UserService) {
  }

  isAuthenticated() {
    if (localStorage.getItem('Authenticated') === null) {
      localStorage.setItem('Authenticated', 'false');
      return false;
    } else if (localStorage.getItem('Authenticated') === 'false') {
      return false;
    } else if (localStorage.getItem('Authenticated') === 'true') {
      if (!this.hasLocalUser()) {
        localStorage.setItem('Authenticated', 'false');
        return false;
      }
      return true;
    }

    localStorage.setItem('Authenticated', 'false');
    return false;
  }

  validateAuthenticatedSession(): boolean | Observable<boolean> {
    if (!this.isAuthenticated()) {
      return false;
    }
    if (this.sessionValidated) {
      return true;
    }
    return this.http.get(this.apiURL.logIn, {observe: 'response', withCredentials: true})
      .map(response => {
        if (response.body) {
          this.userService.setLocal(this.toLocalUser(response.body));
        }
        this.sessionValidated = true;
        return true;
      })
      .catch(() => {
        this.clearClientSession();
        this.router.navigate(['/signin']);
        return Observable.of(false);
      });
  }

  signIn(login, password) {
    const authorization: string = 'Basic ' + btoa(login + ':' + password);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      'Authorization': authorization,
      'offset': this.userService.getTimezoneOffset()
    });

    return this.http.get(this.apiURL.logIn, {headers: headers, observe: 'response', withCredentials: true});
  }

  changePass(login, oldPassword, newPassword) {
    return this.http.post(this.apiURL.changePass + '?' + new HttpParams().set("login", login).set("oldPassword",  oldPassword).set("newPassword",  newPassword), { observe: 'response' });
  }

  signOut() {
    this.sessionValidated = false;
    this.http.post(this.apiURL.logOut, null, {withCredentials: true})
      .subscribe(() => {}, () => {});

    this.clearClientSession();
    this.notificationsService.clearNearNotification();
    this.router.navigate(['/signin']);
  }

  clearClientSession(): void {
    this.sessionValidated = false;
    const lang = localStorage.getItem('lang');
    localStorage.clear();
    if (lang !== null) {
      localStorage.setItem('lang', lang);
    }
    this.cookieService.deleteAll();
  }

  private hasLocalUser(): boolean {
    const rawUser = localStorage.getItem('User');
    if (rawUser === null) {
      return false;
    }
    try {
      return JSON.parse(rawUser) !== null;
    } catch (error) {
      return false;
    }
  }

  private toLocalUser(user: any): any {
    const localUser = Object.assign({}, user);
    localUser.roles = this.normalizeRoles(user.roles);
    localUser.role = this.resolvePrimaryRole(localUser.roles);
    return localUser;
  }

  private normalizeRoles(roles: any[]): string[] {
    if (!roles) {
      return [];
    }
    return roles.map(role => {
      const roleValue = String(role);
      return roleValue.indexOf('ROLE_') === 0 ? roleValue : 'ROLE_' + roleValue;
    });
  }

  private resolvePrimaryRole(roles: string[]): string {
    const priority = ['ROLE_ADMIN', 'ROLE_HEAD', 'ROLE_PARTNER', 'ROLE_USER'];
    for (let index = 0; index < priority.length; index++) {
      if (roles.indexOf(priority[index]) !== -1) {
        return priority[index];
      }
    }
    return roles.length > 0 ? roles[0] : null;
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/auth.service.ts